import api from "../../BaseUrl"; 

// Tüm kullanıcıları getir
export function getUsers() {
  return api.get("/user/users");
}

// Kullanıcı sil
export function deleteUser(id) {
  return api.delete(`/user/${id}`);
}

// Kullanıcı güncelle
export function editUser(id, userData) {
  return api.put(`/user/${id}`, userData);
}
